module.exports = __webpack_public_path__ + "img/imprimax-logo-fundo-branco.4f216645.png";